// extracted by mini-css-extract-plugin
module.exports =  {"seller-level-tooltip":"wyK6zDN","sellerLevelTooltip":"wyK6zDN","seller-level":"d4fHuVP","sellerLevel":"d4fHuVP","top-rated":"xyvgCnY","topRated":"xyvgCnY"};